// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 424) return "static/chunks/181c7756-65102dd077f9e55f.js";
	if (chunkId === 752) return "static/chunks/752-1bf91b5b78a42729.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"d3189c84bc0cd92a","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"b4cc4e72c4ee0607","367":"4f32f5702e8b09bc","639":"e7b660adfa99260e","748":"600378c22a6d274f"}[chunkId] + ".js";
};